export function getStickyHeaderHeight(options?: {
  selector?: string
  fallbackPx?: number
}) {
  const selector = options?.selector ?? "section.sticky.top-0"
  const fallbackPx = options?.fallbackPx ?? 52

  if (typeof document === "undefined") return Math.floor(fallbackPx)

  const height = document.querySelector(selector)?.getBoundingClientRect().height ?? fallbackPx
  return Math.floor(height)
}

